// Unico lugar que guarda o token da sessao para as chamadas a API.
// O App.js alimenta daqui no login e a cada troca de sessao; quem chama
// a API so pede o cabecalho aqui. Dois lugares guardando token acabariam
// divergindo, que e o defeito que mais apareceu neste app.
let _token = null

export function setToken(t) {
  _token = t || null
}

export function hdrAuth() {
  return _token ? { Authorization: "Bearer " + _token } : {}
}
